module.exports = __webpack_public_path__ + "assets/img/126201.b9a85910.svg";